// extracted by mini-css-extract-plugin
export default {"container":"gQPi2TvYcKuv8q_sB7zT"};